import { forEach, isEmpty } from "lodash";

export const userHasRole = (user, roles) => {
  if (!user || !user?.roles?.length || !roles) return true;

  if (typeof roles !== "object") roles = [roles];

  let hasRole = false;

  forEach(user?.roles, (item) => {
    if (roles.includes(item.name)) hasRole = true;
  });

  return hasRole;
};

export const isStoreManager = (user) => {
  return userHasRole(user, ["Builder Manager"]);
};

export const isConsultant = (user) => {
  return userHasRole(user, ["Consultant"]);
};

export const isAdmin = (user) => {
  return userHasRole(user, ["Admin", "Super Admin"]);
};

export const isRoomManager = (user) => {
  return userHasRole(user, ["Room Manager"]);
};

export const isStoreperson = (user) => {
  return userHasRole(user, ["Storeperson"]);
};

export const isInstaller = (user) => {
  return userHasRole(user, ["Installer"]);
};

export const isPAWAdminEnabled = (user, pawAdmin) => {
  if (!user || isEmpty(user)) return false;

  return isAdmin(user) && pawAdmin;
};
